import React, { JSX } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import LzXBaseField from "../BaseField";

import "./SwitchField.scss";

export interface LzPSwitchField {
    fluid?: boolean,
    required?: boolean,
    horizontal?: boolean;
    disabled?: boolean;
    readonly?: boolean;
    compact?: boolean;
    size?: 'small' | 'medium';
    noBottomSpacing?: boolean,
    label?: string,
    name?: string,
    icon?: JSX.Element,
    id?: string,
    className?: string,
    style?: React.CSSProperties,
    value?: boolean,
    onChange?: (name: string, value: boolean) => void
}

const LzXSwitchField = (props: LzPSwitchField) => {

    if (typeof props.value === 'undefined') {
        return <CircularProgress />;
    }

    const theName = props.name || '';
    const theId = props.id || 'id_' + theName;

    const handleOnChange = (): void => {
        if (props.onChange) {
            props.onChange(theName, !props.value);
        }
    };

    const baseStyles = { paddingBottom: 0, marginBottom: 16 };
    if (props.noBottomSpacing) {
        baseStyles.marginBottom = 0;
    }

    if (props.horizontal) {
        return (
            <Grid container spacing={2} className={props.className} sx={{ marginBottom: 1 }}>
                <Grid size={{ sm: 4 }}><Typography variant="overline">{props.label} :</Typography></Grid>
                <Grid size={{ sm: 8 }}>
                    <LzXBaseField
                        id={theId}
                        fluid={props.fluid}
                        required={props.required}
                        disabled={props.disabled}
                        compact={props.compact}
                        size={props.size || 'small'}
                        icon={props.icon}
                        name={props.name}
                        style={baseStyles}
                    >
                        <Switch
                            disabled={props.disabled}
                            name={theName}
                            size={props.size || 'small'}
                            className={'lz-switch ' + (props.className ? props.className : '')}
                            style={props.style || {}}
                            value={1}
                            checked={props.value}
                            onChange={() => handleOnChange()}
                        />
                    </LzXBaseField>
                </Grid>
            </Grid>
        );
    }

    return (
        <LzXBaseField
            id={theId}
            fluid={props.fluid}
            required={props.required}
            disabled={props.disabled}
            compact={props.compact}
            size={props.size || 'small'}
            icon={props.icon}
            name={props.name}
            style={baseStyles}
        >

            <FormControlLabel
                label={props.label}
                control={
                    <Switch
                        disabled={props.disabled}
                        name={theName}
                        size={props.size || 'small'}
                        className={'lz-switch ' + (props.className ? props.className : '')}
                        style={props.style || {}}
                        value={1}
                        checked={props.value}
                        onChange={() => handleOnChange()}
                    />
                }
            />

        </LzXBaseField>
    );
};

export default LzXSwitchField;
